import { KoDate, KoForm, KoFormBuilder, KoSelect, KoSlider, KoUserSelect } from 'packages';
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './timeline.module.scss';
export default function TimelineCurd({form,handleSubmit,initialValues, tasks }) {
  const users = useSelector(state => state?.users);
  const groups = useSelector(state => state?.groups)['data'];

  const Managers = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={users['data']} placeholder='Select Assignee' />;
      

  const ManagersWatchers = ({ value, onChange }) =>
    <KoUserSelect value={value} mode="multiple" onChange={v => onChange(v)} users={users['data']} placeholder='Select Watchers' />;

  const ManagersReporter = ({ value, onChange }) =>
    <KoUserSelect value={value} onChange={v => onChange(v)} users={users['data']} placeholder='Select Reporter' />;

  const ManagersGroups = ({ value, onChange }) =>

    <KoSelect mode="multiple" value={value}
      showSearch
      onChange={v => { onChange(v); }}
      placeholder='Select Groups'
      options={groups?.map((group) => ({
        label: group.name,
        value: group?.groupId
      }))}
    />;

  const TASKLIST = ({ value, onChange }) =>

    <KoSelect mode="multiple" value={value}
      showSearch
      onChange={v => { onChange(v); }}
      placeholder='Select dependency task'
      options={tasks?.map((task) => ({
        label: task.name,
        value: task?.id
      }))}
    />;


  const Date = ({ value, onChange }) =>
    <KoDate value={value} format = {'DD-MMM-YYYY'}
      onChange={v => onChange(v)} />;

  const meta = {
    columns: 6,
    formItemLayout: null,
    colon: false,
    initialValues,
    fields: [
      {
        key: 'name',
        label: 'Summary',
        colSpan: 4,
        rules: [
          { required: true, message: 'Please enter summary.' }
        ]
      },
      {
        key: 'progress',
        label: 'Progress',
        colSpan: 2,
        widget: KoSlider
      },
      {
        key: 'type',
        label: 'Type',
        colSpan: 2,
        widget: 'select',
        options: [
          { label: 'Project', value: 'project' },
          { label: 'Task', value: 'task' },
          { label: 'Milestone', value: 'milestone' }
        ],
        rules: [
          { required: true, message: 'Please select type.' }
        ]
      },
      {
        key: 'start',
        label: 'Start Date',
        colSpan: 2,
        widget: Date,
        rules: [
          { required: true, message: 'Please select start date.' }
        ]
      },
      {
        key: 'end',
        label: 'End Date',
        colSpan: 2,
        widget: Date,
        rules: [
          { required: true, message: 'Please select end date.' }
        ]
      },
     
     
      // {
      //   key: 'hideChildren',
      //   label: 'Hide Children',
      //   colSpan: 2
      // },
      // {
      //   key: 'displayOrder',
      //   label: 'Display Order',
      //   colSpan: 2
      // },
      {
        key: 'assignee',
        label: 'Assignee',
        colSpan: 2,
        widget: Managers,
        rules: [
          { required: true, message: 'Please select assignee.' }
        ]
      },
      {
        key: 'reporter',
        label: 'Reporter',
        colSpan: 2,
        widget: ManagersReporter,
        rules: [
          { required: true, message: 'Please select reporter.' }
        ]
      },
      {
        key: 'teams',
        label: 'Groups',
        colSpan: 2,
        widget: ManagersGroups
      },
    
      {
        key: 'dependencies',
        label: 'Dependencies',
        colSpan: 2,
        widget: TASKLIST
      },
      {
        key: 'watchers',
        label: 'Watchers',
        colSpan: 4,
        widget: ManagersWatchers
      }
      // {
      //   key: 'styles',
      //   label: 'Styles (JSON)',
      //   colSpan: 2,
      //   placeholder: 'Enter styles object'
      // }
     
    ]
  };

  return (
    <div className={styles.crudWrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}
